<template>
  <div>
    <template v-if="!mostrarTokenMobile">
      <v-card class="login-card elevation-8 mb-4 login-card-ajuste mt-5 mx-auto">
        <div class="card-header">
          <div class="header-icon">
            <v-icon size="32" color="white">mdi-account-key</v-icon>
          </div>
          <h2 class="header-title">Acesso ao Sistema</h2>
        </div>
        <v-card-text class="pa-6">
          <small> Usuário (CPF ou E-mail) </small>
          <v-text-field
            v-model="usuario"
            required
            outlined
            prepend-inner-icon="mdi-account"
            maxlength="14"
            @input="aplicarMascaraCpf"
            v-show="1 != 1"
          />
          <small>Senha</small>
          <v-text-field
            v-model="senha"
            required
            outlined
            prepend-inner-icon="mdi-lock"
            type="password"
            maxlength="50"
            v-show="1 != 1"
          />
          <v-btn v-show="1 != 1" @click="logar" color="primary" class="validate-btn elevation-4 mt-4" block large>
            <v-icon left>mdi-login</v-icon>
            Entrar
          </v-btn>
          <v-btn
            v-if="!temTokenMobile"
            @click="mostrarTokenMobile = true"
            color="orange darken-2"
            outlined
            class="validate-btn elevation-2 mt-3"
            block
            large
          >
            <v-icon left>mdi-cellphone-key</v-icon>
            Solicitar Token
          </v-btn>
          <div v-show="1 != 1" class="mt-2 text-center">
            <a href="#" @click.prevent="irParaRecuperarSenha" class="recuperar-link">Esqueci minha senha</a>
          </div>
        </v-card-text>
      </v-card>
    </template>

    <SolicitarTokenMobile v-else @voltar="mostrarTokenMobile = false" />

    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center">
          <v-progress-circular indeterminate color="white" size="40" class="mb-4" />
          <span>Aguarde...</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CredenciamentoServices from "@/services/acesso/CredenciamentoServices";
import filters from "@/libs/filters";
import SolicitarTokenMobile from "@/components/acesso/SolicitarTokenMobile.vue";
export default {
  name: "login",
  components: { SolicitarTokenMobile },
  data: () => ({
    usuario: "",
    senha: "",
    loading: false,
    mostrarTokenMobile: false,
  }),
  computed: {
    temTokenMobile() {
      try {
        const token = localStorage.getItem("token");
        if (!token) return false;
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.mobile === true;
      } catch {
        return false;
      }
    },
  },
  mounted() {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const expirado = payload.exp && payload.exp * 1000 < Date.now();
      if (expirado) {
        localStorage.removeItem("token");
        return;
      }
      this.$router.push({ name: "homeMain" });
    } catch {
      localStorage.removeItem("token");
    }
  },
  methods: {
    aplicarMascaraCpf() {
      const valor = this.usuario.replace(/\D/g, "");
      if (valor.length <= 11) {
        this.usuario = filters.filterCpf(valor);
      }
    },
    async logar() {
      if (!this.usuario || !this.senha) {
        this.$toast.error("Por favor, preencha todos os campos.");
        return;
      }
      this.loading = true;
      try {
        const response = await CredenciamentoServices.login({ usuario: this.usuario, senha: this.senha });

        if (response.success) {
          if (response.data && response.data.token) {
            localStorage.setItem("token", response.data.token);

            CredenciamentoServices.validarLog();
            if (this.$root && this.$root.EventBus) {
              this.$root.EventBus.$emit("token-updated", response.data.token);
            }
          }
          this.$toast.success("Login realizado com sucesso!");
          this.$router.push({ name: "homeMain" });
        } else {
          this.$toast.error(response.message || "Falha no login. Verifique suas credenciais.");
        }
      } catch (error) {
        this.$toast.error("Ocorreu um erro ao tentar fazer login. Tente novamente mais tarde.");
      } finally {
        this.loading = false;
      }
    },
    irParaRecuperarSenha() {
      this.$router.push({ name: "RecuperarSenha" });
    },
  },
};
</script>

<style scoped>
.login-card-ajuste {
  max-width: 700px;

  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  padding: 32px 40px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 800px) {
  .login-card-ajuste {
    padding: 24px 16px !important;
    width: 700px;
  }
}
@media (max-width: 600px) {
  .login-card-ajuste {
    max-width: 98vw;
    padding: 12px 4px !important;
  }
}
@media (max-width: 600px) {
  .login-card-ajuste {
    max-width: 98vw;
    padding: 8px !important;
  }
}
.recuperar-link {
  color: #d84315;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  font-size: 1rem;
  transition: color 0.2s;
}
.recuperar-link:hover {
  color: #bcaaa4;
}
.login-container {
  background: linear-gradient(135deg, #efebe9 0%, #bcaaa4 100%);
  min-height: 100vh;
  padding: 24px 16px;
}

.min-height-screen {
  min-height: calc(100vh - 48px);
}

.main-wrapper {
  animation: fadeInUp 0.8s ease-out;
}

.loading-dialog {
  border-radius: 16px !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.back-card {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  border-radius: 12px !important;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.back-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(231, 76, 60, 0.3) !important;
}

.back-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.back-text {
  color: white;
  font-weight: 500;
  font-size: 1rem;
}

.login-card {
  border-radius: 16px !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  overflow: hidden;
  animation: slideInUp 0.6s ease-out 0.2s both;
}

.card-header {
  background: linear-gradient(135deg, #ffccbc 0%, #d84315 100%);
  padding: 24px;
  text-align: center;
  position: relative;
  width: 100%;
}

.card-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.header-icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-bottom: 16px;
}

.header-title {
  position: relative;
  z-index: 1;
  color: white;
  font-weight: 300;
  margin: 0;
}

.custom-alert {
  border-radius: 8px !important;
  background: rgba(33, 150, 243, 0.05) !important;
}

.custom-input {
  margin-bottom: 16px;
}

.validate-btn {
  border-radius: 8px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}

.error-alert {
  border-radius: 8px !important;
  animation: shake 0.5s ease-in-out;
}

.results-container {
  animation: fadeInUp 0.6s ease-out 0.4s both;
}

.result-card {
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideInLeft 0.6s ease-out both;
}

.result-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.2) !important;
}

.result-header {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.result-title {
  font-weight: 600;
  color: #2c3e50;
  font-size: 1rem;
}

.info-item {
  margin-bottom: 12px;
  line-height: 1.5;
  color: #34495e;
}

.info-item strong {
  color: #2c3e50;
  margin-right: 8px;
}

.institution-name {
  color: #3498db;
  font-weight: 600;
}

.students-list,
.matriculas-list {
  margin-top: 8px;
  margin-left: 16px;
}

.student-item,
.matricula-item {
  display: block;
  padding: 4px 0;
  color: #555;
  border-left: 3px solid #e74c3c;
  padding-left: 12px;
  margin-bottom: 4px;
}

.action-section {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding-top: 16px;
}

.action-btn {
  border-radius: 8px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}

.status-alert {
  border-radius: 8px !important;
  margin: 0 !important;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}

/* Mobile Responsive */
@media (max-width: 599px) {
  .login-container {
    padding: 16px 8px;
  }

  .card-header {
    padding: 20px 16px;
  }

  .header-icon {
    width: 56px;
    height: 56px;
    margin-bottom: 12px;
  }

  .header-title {
    font-size: 1.3rem;
  }

  .back-text {
    font-size: 0.9rem;
  }

  .result-header {
    padding: 12px 16px;
  }

  .students-list,
  .matriculas-list {
    margin-left: 8px;
  }
}

@media (max-width: 959px) and (min-width: 600px) {
  .card-header {
    padding: 28px 20px;
  }
}

@media (min-width: 1264px) {
  .result-card {
    margin-bottom: 20px !important;
  }
}
</style>
